module.exports = __webpack_public_path__ + "assets/img/cd01c1c48d6e7dac1d369f3593b0a33a.png";